<template>
    <div :style="`z-index: ${zIndex}`">
        <div class="w-full shadow-lg transform blur-dim" :style="inlineStyles">
            <img :src="cardImage" :alt="card.label" />
        </div>
    </div>
</template>

<script>
import { cardImageUrl } from '@/util/cards';

export default {
    props: [
        'animate',
        'total',
        'perRow',
        'isSafari',
        'label',
        'index',
        'cellHeight',
    ],
    data() {
        return {
            rotateMax: 75,
            maxScale: 1.25,
            minScale: 0.75,
        };
    },
    computed: {
        inlineStyles() {
            return [
                '--aspect-ratio:239*335;',
                `--transform-scale-x: ${this.scale};`,
                `--transform-scale-y: ${this.scale};`,
                `--blur-amount: ${this.blur}px;`,
                `--brightness: ${this.brightness}%`,
            ].join(' ');
        },
        card() {
            return window.ratT.cards[this.label];
        },
        cardImage() {
            return cardImageUrl(this.card.image);
        },
        scale() {
            return (
                gsap.utils.random(this.minScale * 10, this.maxScale * 10) / 10
            );
        },
        zIndex() {
            return Math.floor(this.scale * this.total);
        },
        blur() {
            if (this.isSafari) {
                // Safari renders the blur too much no matter how little the blur, just don't blur
                return 0;
            }

            const factor = 1.75;

            return factor * (this.maxScale - this.scale);
        },
        brightness() {
            const factor = 15;

            return 100 - factor * (this.maxScale - this.scale);
        },
        rotateStart() {
            return gsap.utils.random(-this.rotateMax, this.rotateMax);
        },
        rotateEnd() {
            return gsap.utils.random(-this.rotateMax, this.rotateMax);
        },
        duration() {
            // Higher rows need less time, lower rows need more time
            return gsap.utils.random(
                3.5 * (10 / this.row),
                5 * (10 / this.row),
            );
        },
        row() {
            return Math.floor(this.index / this.perRow) + 1;
        },
        totalRows() {
            return this.total / this.perRow;
        },
        delay() {
            return (this.totalRows - this.row) * 0.5;
        },
        yStart() {
            return this.row * this.cellHeight * -1 - 25;
        },
        yEnd() {
            return (
                Math.abs(this.totalRows - this.row + 1) * this.cellHeight + 25
            );
        },
    },
    mounted() {
        if (!this.animate) {
            return;
        }

        const tl = gsap.timeline({
            ease: Linear.easeNone,
            repeat: -1,
            force3D: true,
            delay: this.delay,
            repeatDelay: 0,
        });

        tl.fromTo(
            this.$el,
            {
                y: this.yStart,
                rotate: this.rotateStart,
                ease: Linear.easeNone,
            },
            {
                y: this.yEnd,
                rotate: this.rotateEnd,
                duration: this.duration,
                ease: Linear.easeNone,
            },
        );
    },
};
</script>
